import { rupiah } from "@/lib/api";

const slugify = (t) => (t || "").toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

// Open WhatsApp with a ready-to-send message for a schedule.
// `driverName` is an optional fallback when the schedule object has no driver_name.
export const shareScheduleToWA = (s, driverName) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const prefix = s.service_type === "charter" ? "charter-drop-off" : "travel";
  const url = `${origin}/${prefix}-${slugify(s.origin)}-${slugify(s.destination)}`;
  const name = s.driver_name || driverName || "Travel";
  const seats = s.seats_left != null ? `💺 ${s.seats_left} kursi tersisa\n` : "";
  const msg =
    `🚐 *Jadwal Travel Travele*\n` +
    `${s.origin} → ${s.destination}\n` +
    `🕐 ${s.time} · ${s.date}\n` +
    `🚙 ${s.vehicle_name} · ${name}\n` +
    seats +
    `💰 mulai ${rupiah(s.price)}/penumpang\n\n` +
    `Pesan di: ${url}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
};

// Open WhatsApp with a ready-to-send message promoting a driver / PO profile page.
export const shareDriverToWA = (d) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const slug = d.slug || slugify(d.business_name);
  const url = `${origin}/driver/${slug}`;
  const rating = d.avg_rating ? `⭐ ${d.avg_rating}` : "⭐ Baru";
  const stats = `${rating} · ${d.rating_count || 0} ulasan · ${d.total_trips || 0} perjalanan`;
  const msg =
    `🚐 *${d.business_name}* di Travele\n` +
    (d.city ? `📍 ${d.city}\n` : "") +
    `${stats}\n\n` +
    `Lihat armada, jadwal keberangkatan & pesan langsung di:\n${url}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
};
